@if (true) {
<div class="wrap center bg-col-51 p-t-10 p-b-6">
    <h2 class="h1"
        sizeClass="SM:h2 p-r-8 p-l-8"
        *iCms="'title' of component; skipEmpty: true">
    </h2>
    <p class="p1"
       sizeClass="SM:p-r-8 p-l-8 m-t-1, LX:m-t-2"
       *iCms="'subtitle' of component; skipEmpty: true">
    </p>
    @if (component.ctaText && component.ctaLink) {
    <div class="w-12"
         sizeClass="SM:center m-t-3, LX:right">
        <href [link]="component?.ctaLink">
            <span class="button-inline">
                <span class="button__body"
                      *iCms="'ctaText' of component"></span>
            </span>
        </href>
    </div>
    }
    <div class="w-12 flex m-t-3 flex-column-s"
         sizeClass="SM:m-t-7">
        @for (model of listingAsBlogPosts?.models; track $index; let isFirst = $first; let isLast = $last) {
        <div class="w-4 w-12-s w-12-m p-a-0-s"
             [ngClass]="{'p-r-2' : isFirst, 'p-l-2' : isLast, 'p-l-1 p-r-1': (!isFirst&&!isLast) }">
            <href class="w-12"
                  [link]="model.data?.url">
                <df-image-wrapper>
                    <img class="rf"
                         [ratio]="4/3"
                         [dfImage]="model.data?.image">
                </df-image-wrapper>
            </href>
            <div class="m-t-2 m-t-3-s left p-a-2 p-t-1-s p-t-1-m p-b-8-s p-b-8-m">
                <p class="m-t-2 m-t-0-s p1">{{'Latest News' | translate}}</p>
                <href [link]="model.data?.url">
                    <h2 class="h2">
                        {{model.data?.typeData?.title || model.data.name}}
                    </h2>
                </href>
                @if (model.data?.typeData?.short_description) {
                <div class="m-t-2 p1"
                     [innerHtml]="model.data?.typeData?.short_description">
                </div>
                }
                <a class="button-inline"
                   [routerLink]="model.data?.url">
                    <span class="m-t button__body">{{'Read more' | translate}}</span>
                </a>
            </div>
        </div>
        }
    </div>
</div>
}